export default "__VITE_ASSET__eff1b997__"